import { makeStyles } from '@mui/styles';

const useProcessEditionFormStyles = makeStyles(() => ({
	accordion: {
		border: '1px solid rgba(0, 0, 0, 0.12)',
		borderLeft: 'none',
		borderRight: 'none',
		boxShadow: 'none !important',
		marginTop: 24,
		'&::before': {
			display: 'none',
		},
	},
}));

export default useProcessEditionFormStyles;
